import { convertDistance, getDistance } from 'geolib';

export type NonNullableRecord<T extends object | undefined | null> = Required<{
  [k in keyof T]-?: NonNullable<T[k]>;
}>;

const getUserDisplayUnits = ({ imperialUnitsSetting }: { imperialUnitsSetting: boolean }) =>
  imperialUnitsSetting ? 'mi' : 'km';

const hasValidLocation = (address: Geolocation | null): address is NonNullableRecord<Geolocation> =>
  address !== null && typeof address.latitude === 'number' && typeof address.longitude === 'number';

export type Geolocation = {
  latitude?: number | null;
  longitude?: number | null;
};

export type Locatable = {
  address: Geolocation | null;
};

export type LocatableUser = Locatable & { imperialUnitsSetting: boolean };

const calcUserProjectDistance = (
  user: LocatableUser,
  project: Locatable,
  units: string | null = null,
) => {
  const userAddress = user.address;
  const projectAddress = project.address;
  const validCoords = hasValidLocation(userAddress) && hasValidLocation(projectAddress);

  if (!validCoords) return null;

  const distanceInMeters = getDistance(
    {
      latitude: userAddress.latitude,
      longitude: userAddress.longitude,
    },
    {
      latitude: projectAddress.latitude,
      longitude: projectAddress.longitude,
    },
  );

  const exactDistance = convertDistance(distanceInMeters, units || getUserDisplayUnits(user));

  return Math.round(exactDistance);
};

export { calcUserProjectDistance, getUserDisplayUnits };
